import { Component, Inject, Optional, OnInit } from '@angular/core';
import { LoginService } from '../../services/login.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.scss']
})
export class CustomerListComponent implements OnInit {
  customerList: any;
  loading = false;
  settings = {
    // actions: false,
    actions: {
      columnTitle: 'Login',
      add: false,
      edit: false,
      delete: true,
      custom: [
        { name: 'editrecord', title: '<i class="fa fa-sign-in" aria-hidden="true"></i>' }
      ],
      position: 'right'
    },
    pager: {
      display: true,
      perPage: 4
    },
    add: {
      confirmCreate: true,
    },
    columns: {
      CustomerName: {
        title: 'Customer Name'
      },
    }
  };

  constructor(public dialogRef: MatDialogRef<CustomerListComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private loginService: LoginService, ) { }

  ngOnInit() {
    this.loading = true;
    this.loginService.getCustomerUserInformation().subscribe((res) => {
      this.loading = false;
      this.customerList = res;
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  onCustomAction(event) {
    let strEmail = event.data.Email;
    sessionStorage.setItem('currentUserEmail', strEmail);
    this.dialogRef.close(1);
  }


}
